export * from "./enterprise-landing-page.template";
export { EnterpriseLandingPageTemplate as Default } from "./enterprise-landing-page.template";
